export default "__VITE_ASSET__BdxR_Z5a__"